import { Injectable, inject } from '@angular/core';
import MapView from '@arcgis/core/views/MapView';
import SceneView from '@arcgis/core/views/SceneView';
import { NGXLogger } from 'ngx-logger';
import { Observable, Subject } from 'rxjs';
import type { LayerViewCreateEvent } from "@arcgis/core/views/input/types";

export interface TimeIntervalMetricValue {
  id: string | number;
  start: Date;
  end: Date;
  duration: number;
}

export class TimeIntervalMetric {
  start: Date;
  private _end!: Date;

  end(date: Date = new Date()) {
    this._end = date;
    this.duration = this._end.getTime() - this.start.getTime();
  }
  duration!: number;

  get value(): TimeIntervalMetricValue {
    return {
      id: this.id,
      start: this.start,
      end: this._end,
      duration: this.duration
    };
  }
  constructor(
    public id: string,
    start = new Date()
  ) {
    this.start = start;
  }
}

@Injectable({
  providedIn: 'root'
})
export class MetricsService {
  private readonly _logger = inject(NGXLogger);
  private _componentStartTime!: Date;

  set componentStartTime(date: Date) {
    this._componentStartTime = date;
  }

  get componentStartTime(): Date {
    return this._componentStartTime;
  }

  trackLayerLoadTime(
    layerName: string,
    mapView: MapView | SceneView
  ): Observable<LayerViewCreateEvent> {
    const subj = new Subject<LayerViewCreateEvent>();
    const metric = new TimeIntervalMetric(layerName);
    if (mapView) {
      const handle = mapView?.on?.(
        'layerview-create',
        (event: LayerViewCreateEvent) => {
          if (event.layer.id === layerName) {
            metric.end();
            this.logMetric(metric, 'LayerViewCreate');
            handle.remove();
            subj.next(event);
            subj.complete();
          }
        }
      );
    }
    return subj.asObservable();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackMapLoadTime() {
    // const metric = new TimeIntervalMetric('MapViewCreate');
    // const mapView = this._api.getMapView();
    // if (mapView) {
    //   return this._api.getMapView().when(() => {
    //     metric.end();
    //     this.logMetric(metric);
    //   });
    // }
    // return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackSceneLoadTime() {
    // const metric = new TimeIntervalMetric('SceneViewCreate');
    // const mapView = this._api.getMapView();
    // if (mapView) {
    //   return this._api.getSceneView().when(() => {
    //     metric.end();
    //     this.logMetric(metric);
    //   });
    // }
    // return null;
  }

  logMetric(metric: TimeIntervalMetric, title?: string) {
    if (metric) {
      const logTitle = title ? title : metric.id;
      this._logger.trace(
        `[Metrics] ${logTitle} in ${metric.duration}ms:`,
        metric
      );
    }
  }
}
